import {Accordion} from "./Accordion";
import {Component} from "./Component";
import {createLogger} from "../util/logger";

const console = createLogger("AccordionGroup");

export class AccordionGroup extends Component {

    static name = "accordion-group";

    constructor(el) {
        super(el);

        /**
         * @type {HTMLElement[]}
         */
        this.elements = Array.from(this.el.querySelectorAll(Accordion.getModuleSelector()));

        /**
         * @type {Accordion[]}
         */
        this.accordions = this.elements.map((el) => {
            const instance = Accordion.create(el);
            instance.on("open", this.onOpenAccordion.bind(this));
            return instance;
        });

        console.log("constructor", this);
    }

    /**
     * open event listener for accordions
     * @param {Accordion} instance
     */
    onOpenAccordion(instance) {
        console.log("onOpenAccordion", instance);
        // Close other opened accordions when accordion is opened
        this.accordions.forEach((acc) => {
            if (acc === instance) return;

            console.log("close", acc)
            acc.close();
        });
    }

}
